<template>
  <ItemDialog ref="dialogRef" imageType="alert" :initialOpen="false">
    <template v-slot:content-area>
      <h2>この予約をキャンセルしてよろしいですか？</h2>
    </template>
    <template v-slot:button-area>
      <ItemButton label="キャンセルする" actionType="btn-primary" @clicked="onClickCancel()" />
      <ItemButton label="戻る" actionType="btn-cancel" @clicked="closeDialog()" />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogCancelConfirm",
  props: {
    onClickCancel: {
      type: Function,
      require: true
    }
  },
  setup() {
    const dialogRef = ref(null);

    const openDialog = () => {
      dialogRef.value.open();
    };

    const closeDialog = () => {
      dialogRef.value.close();
    };

    return {
      dialogRef,
      openDialog,
      closeDialog,
    };
  },
};
</script>